import myVirtualCard from './VirtualCardList';
import virtualcardDetails from './VirtualCardDetails';

export default [myVirtualCard, virtualcardDetails];
